import { useContext, useState } from 'react'
import type { ChangeEvent, InputHTMLAttributes } from 'react'
import styled from 'styled-components'

import { Container, InputContext } from './InputContext'

import { ReactComponent as CloseFocus } from '../../assets/ico/common/close/close_black.svg'
import { ReactComponent as CloseBlur } from '../../assets/ico/common/close/close_gray.svg'

type InputAttributes = InputHTMLAttributes<HTMLInputElement>

interface InputProps extends InputAttributes {
  $shape?: 'box' | 'line'
  block?: boolean
  multiline?: boolean
  onRemove?: () => void
}

function Inner({ value: _value, type, defaultValue, placeholder, onChange, onRemove, ...props }: InputProps) {
  const { isFocus, handleBlur, handleFocus, handleKeyDown } = useContext(InputContext)

  const [value, setValue] = useState<InputProps['value']>(_value)

  const emptyValue = () => {
    setValue('')
    onRemove?.()
  }

  const handleValue = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e)
    setValue(e.target.value)
  }

  return (
    <>
      <input
        {...props}
        type={type}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={handleValue}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />
      <EmptyButton onMouseDown={emptyValue}>{isFocus ? <CloseFocus /> : <CloseBlur />}</EmptyButton>
    </>
  )
}

export function Line(props: InputProps) {
  return (
    <Container $shape="line" {...props}>
      <Inner {...props} />
    </Container>
  )
}

const EmptyButton = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  background: none;
`

export type { InputProps }
